// extracted by mini-css-extract-plugin
export var checkbox = "_3e-0";
export var circle = "_3e-3";
export var horizontalContainer = "_3e-7";
export var sm = "_3e-5";
export var switch0 = "_3e-2";
export var switchDisabled = "_3e-8";
export var switchEnabled = "_3e-1";
export var textSwitchContainer = "_3e-9";
export var textSwitchOption = "_3e-a";
export var textSwitchOptionSelected = "_3e-b";
export var verticalContainer = "_3e-6";
export var xs = "_3e-4";